import { render, staticRenderFns } from "./PaySucceed.vue?vue&type=template&id=25ae6760&scoped=true&"
import script from "./PaySucceed.vue?vue&type=script&lang=js&"
export * from "./PaySucceed.vue?vue&type=script&lang=js&"
import style0 from "./PaySucceed.vue?vue&type=style&index=0&id=25ae6760&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ae6760",
  null
  
)

export default component.exports